module.exports = __webpack_public_path__ + "static/media/exercises-step11.382c88b3.png";